module.exports = __webpack_public_path__ + "static/media/elly.9a7f5e26.png";